import { TranslateInstance } from '@shared/utils/TranslateInstance';

export function getGeneralMessage(message: string, isSuccess = true): string {
  const translatedMessage = TranslateInstance.translateService.instant(message);
  const postFix = isSuccess ? 'success' : 'error';
  return TranslateInstance.translateService.instant(`common.general_${postFix}`, {
    message: translatedMessage,
  });
}
